/**
 * ToastHost — renders the transient-toast stack (ui/toast.ts).
 *
 * Mounted inside the shell via `shellPortal` so toasts stay iPad-bound
 * (DEC-096) — a `position: fixed` node inside the scaled `.shell` fixes to
 * the iPad frame, not the browser viewport, so the stack sits at the bottom
 * of the frame in both the desktop preview and on-device. Sits above every
 * shell modal (high z in CSS) since a panic result must be visible even
 * over an open Settings / Connect panel.
 */

import { For, Show } from 'solid-js';
import { Portal } from 'solid-js/web';
import { shellPortal } from '../layout/shellPortal.ts';
import { toasts, dismissToast } from '../ui/toast.ts';

export function ToastHost() {
  return (
    <Show when={toasts().length > 0}>
      <Portal mount={shellPortal() ?? document.body}>
        <div class="toast-host" role="status" aria-live="polite">
          <For each={toasts()}>
            {(t) => (
              <button
                type="button"
                class="toast"
                data-kind={t.kind}
                onClick={() => dismissToast(t.id)}
                title="Dismiss"
              >
                {t.message}
              </button>
            )}
          </For>
        </div>
      </Portal>
    </Show>
  );
}
